import React, { useEffect, useState } from "react";
import { Alert, Modal, Skeleton } from "antd";
import { SelDominio } from "../../Selecao/Dominio/Sel_Dominio";
import { SelTabela } from "../../Selecao/Tabela/Sel_tabela";
import { ModalAddFields } from "../CadastroTabelas/components/modalAddFields";
import { ModalInsert as EditarForeignKey } from "../CadastroTabelas/foreignKey/components/modalInsert";
import { ModalInsert as EditarPrimaryKey } from "../CadastroTabelas/primaryKey/components/modalInsert";
import { ModalInsert as EditarIndex } from "../CadastroTabelas/indexSreen/components/modalInsert";
import { ModalInsert as EditarTrigger } from "../CadastroTabelas/trigger/components/modalInsert";
import { ModalInserir as EditarProcedure } from "../CadastroProcedure/components/modais/inserir";
import { ModalInsert as EditarView } from "../CadastroView/componentes/modais/insert";
import { ModalInserir as EditarSequence } from "../CadastroSequence/componentes/modais/modalInserir";
import { ModalInserir as EditarComando } from "../Comandos/modalInserir";
import { ModalAdd as EditarParametro } from "../ConfigMocked/modal";
import { ModalInserir as EditarPermissao } from "../CadastroMenu/menu-id/componentes/modais/modalInserir";
import TabelaRequest from "../CadastroTabelas/tabelaRequest";
import foreignRequest from "../CadastroTabelas/foreignKey/foreignRequest";
import { primaryRequest } from "../CadastroTabelas/primaryKey/primaryRequest";
import { indexRequest } from "../CadastroTabelas/indexSreen/indexRequest";
import { triggerRequest } from "../CadastroTabelas/trigger/triggerRequest";
import { newConfigRequest } from "../ConfigMocked/request";
import { menuRequest } from "../CadastroMenu/menuRequest";
import { sistemaRequest } from "../../Utils/sistemaRequest";

// A consulta traz nomes dos vínculos; os cadastros precisam dos IDs ao salvar
// e ao limitar a seleção de campos à tabela do registro.
const carregarDetalhes = {
  campo_em_teste: TabelaRequest.getCampoId,
  foreignKey_em_teste: foreignRequest.getForeignId,
  primaryKey_em_teste: primaryRequest.getPrimaryKeyId,
  index_em_teste: indexRequest.getIndexId,
  trigger_em_teste: triggerRequest.getTriggerId,
  parametro_em_teste: newConfigRequest.getConfig,
  permissao_em_teste: menuRequest.getMenuItemId,
};

export const EditarRegistro = ({ tipo, registro, onCancel, onSave }) => {
  const [contexto, setContexto] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let ativo = true;
    const carregar = async () => {
      try {
        const buscar = carregarDetalhes[tipo];
        const dados = buscar ? (await buscar(registro.id)).data : registro;
        let tabelaId = dados.tabela_id ?? dados.campo__tabela_id;
        if (["foreignKey_em_teste", "primaryKey_em_teste", "index_em_teste"].includes(tipo)
          && tabelaId == null && dados.campo_id != null) {
          tabelaId = (await TabelaRequest.getCampoId(dados.campo_id)).data.tabela_id;
        }
        const vinculoId = tipo === "parametro_em_teste" ? dados.config_grupo_id
          : tipo === "permissao_em_teste" ? dados.menu_id : tabelaId;
        if (buscar && vinculoId == null) {
          throw new Error("Vínculo do cadastro não encontrado.");
        }
        let sistemas = [];
        if (tipo === "comando_em_teste") {
          const { data } = await sistemaRequest.getSistemas();
          const listaSistemas = Array.isArray(data) ? data : data.results;
          sistemas = listaSistemas.map((item) => ({
            label: item.nome_sistema, value: item.id,
          }));
        }
        if (ativo) setContexto({ dados, tabelaId, sistemas });
      } catch (error) {
        if (ativo) setErro(true);
      }
    };
    carregar();
    return () => { ativo = false; };
  }, [tipo, registro]);

  if (!contexto) {
    return (
      <Modal visible title="Alterar registro" footer={null} onCancel={onCancel}>
        {erro ? (
          <Alert type="error" showIcon message="Não foi possível carregar o cadastro. Feche e tente novamente." />
        ) : <Skeleton active />}
      </Modal>
    );
  }

  // Os formulários chamam estes callbacks somente após a API confirmar a alteração.
  const props = { visible: true, onCancel, id: registro.id };
  const { dados, tabelaId, sistemas } = contexto;
  switch (tipo) {
    case "dominio_em_teste":
      return <SelDominio {...props} estadoDominio={onSave} />;
    case "tabela_em_teste":
      return <SelTabela {...props} estadoTabela={onSave} />;
    case "campo_em_teste":
      return <ModalAddFields {...props} tabela_id={tabelaId} estadoCampo={onSave} />;
    case "foreignKey_em_teste":
      return <EditarForeignKey {...props} open id={tabelaId} idEdit={registro.id} estadoFk={onSave} />;
    case "primaryKey_em_teste":
      return <EditarPrimaryKey {...props} id={tabelaId} idPK={registro.id} estadoPk={onSave} />;
    case "index_em_teste":
      return <EditarIndex {...props} id={tabelaId} idIndex={registro.id} estadoIndex={onSave} />;
    case "trigger_em_teste":
      return <EditarTrigger {...props} id={tabelaId} idTrigger={registro.id} estadoTriggers={onSave} />;
    case "procedure_em_teste":
      return <EditarProcedure {...props} estadoProcedure={onSave} />;
    case "view_em_teste":
      return <EditarView {...props} estadoView={onSave} />;
    case "sequences_em_teste":
      return <EditarSequence {...props} estadoSequence={onSave} />;
    case "comando_em_teste":
      return <EditarComando {...props} optionsSistemas={sistemas} estadoComandos={onSave} />;
    case "parametro_em_teste":
      return <EditarParametro {...props} idGrupo={dados.config_grupo_id} editarConfig={onSave} atualizarLista={onSave} />;
    case "permissao_em_teste":
      return <EditarPermissao {...props} id={dados.menu_id} idItem={registro.id} estadoPermissao={onSave} />;
    default:
      return null;
  }
};
